import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { forgetPassword } from '../../actions/authenticateActions';
import { notify } from '../../util/notifications';
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import { required, email } from '../../util/validationMethods';
import TmInputGroup from '../../components/utilComponents/tmInputGroup/tmInputGroup';
import Background from '../../assets/img/bg_body.jpg';
import { forgetOptions } from '../../util/constants';
import './login.css';

/**
 * ForgetPassword Component
 * ─────────────────────────────────────────────────────
 * CHANGES:
 *  1. Fixed direct state mutation in onChangeValues
 *  2. Added try/catch around handleSubmit
 *  3. Removed unused imports (authenticateUser, Input, Link)
 *  4. Removed unused pageTitle constant
 */

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: '',
      forgetOption: forgetOptions.FORGET_USER,
    };
  }

  onChangeValues = (event) => {
    const { name, value } = event.currentTarget;
    this.setState({ [name]: value });
  };

  handleSubmit = async () => {
    const { dispatch } = this.props;

    try {
      const res = await dispatch(
        forgetPassword(this.state.emailId, this.state.forgetOption)
      );

      if (res.statusCode === 200) {
        notify.createNotification('success', res.message, this.props.refNotify);
      } else {
        notify.createNotification('error', res.statusMsg, this.props.refNotify);
      }
    } catch (error) {
      console.error('Account recovery error:', error);
      const message =
        error?.response?.data?.statusMsg || 'Failed to process request. Please try again.';
      notify.createNotification('error', message, this.props.refNotify);
    }
  };

  render() {
    return (
      <section
        className="wrapper"
        style={{
          backgroundImage: `url(${Background})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
        }}
      >
        <div className="login-wrap d-flex align-items-center flex-wrap justify-content-center pd-20">
          <div className="login-box bg-white box-shadow pd-20 border-radius-5">
            <img
              src={require('../../assets/images/NN Logo Final-01.png')}
              alt="NaviNet"
              className="login-img"
            />
            <h6 className="text-center mb-10">
              <strong>Account Recovery</strong>
            </h6>
            <Form name="frmForgot" className="mb-lg">
              <Fragment>
                <div className="row">
                  <div className="col-sm-12 mb-10">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name="forgetOption"
                        id="fguser"
                        value={forgetOptions.FORGET_USER}
                        checked={this.state.forgetOption === forgetOptions.FORGET_USER}
                        onChange={this.onChangeValues}
                      />
                      <label htmlFor="fguser" className="custom-control-label">
                        Forgot User Name
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-12 mb-10">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name="forgetOption"
                        id="fgpwd"
                        value={forgetOptions.FORGET_PASS}
                        checked={this.state.forgetOption === forgetOptions.FORGET_PASS}
                        onChange={this.onChangeValues}
                      />
                      <label htmlFor="fgpwd" className="custom-control-label">
                        Forgot Password
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-12 mb-10">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name="forgetOption"
                        id="fgboth"
                        value={forgetOptions.FORGET_BOTH}
                        checked={this.state.forgetOption === forgetOptions.FORGET_BOTH}
                        onChange={this.onChangeValues}
                      />
                      <label htmlFor="fgboth" className="custom-control-label">
                        Forgot Both (User Name and Password)
                      </label>
                    </div>
                  </div>
                </div>

                <div className="input-group custom input-group-lg">
                  <TmInputGroup
                    id="userEmailId"
                    name="emailId"
                    type="text"
                    placeholder="Enter User Email Id"
                    className="form-control"
                    value={this.state.emailId}
                    validations={[required, email]}
                    onChange={this.onChangeValues}
                    requiredmsg="User email is required!"
                    append="true"
                    appendText={
                      <div className="input-group-append custom">
                        <span className="input-group-text">
                          <i className="fa fa-user" aria-hidden="true" />
                        </span>
                      </div>
                    }
                  />
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="input-group">
                      <Button
                        type="button"
                        onClick={this.handleSubmit}
                        className="btn btn-outline-primary btn-lg btn-block"
                      >
                        Submit
                      </Button>
                    </div>
                    <div className="input-group">
                      <input
                        type="button"
                        value="Back"
                        style={{ textTransform: 'inherit' }}
                        onClick={() => this.props.history.push('/login')}
                        className="btn btn-outline-primary btn-lg btn-block"
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            </Form>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo,
  refNotify: state.refNotify,
});

export default withRouter(connect(mapStateToProps)(ForgetPassword));
